import Constants from './Constants';

/**
 * Example: extend({}, objA, objB);
 *
 * @export
 * @param {any} out Extended object.
 * @returns Extended object.
 */
function extend(...args) {
    const out = args[0] || {};
    for (let i = 1; i < args.length; i++) {
        if (!args[i]) continue;
        const keys = Object.keys(args[i]);
        for (let ki = 0; ki < keys.length; ki++) {
            const key = keys[ki];
            out[key] = args[i][key];
        }
    }
    return out;
}

/**
 * Used to extend the user object for permission checking.
 *
 * @param {*} cid Company ID
 * @param {*} permissions Permission id(s)
 */
function has(cid, permissions) {
    if (this.FA) return true; // Full admin on user therefore no need to check anything else.
    const company = this.C.find(o => o._id === cid);
    if (company.Perms.P.indexOf(Constants.PERMISSION.FULL_ADMIN) > -1) return true; // Full admin in role therefore no need to check anything else.

    if (!Array.isArray(permissions)) permissions = [permissions]; // Make array if not.
    for (let i = 0; i < permissions.length; i++) { // Check each role.
        if (company.Perms.P.indexOf(permissions[i]) > -1) {
            return true; // Return on first find.
        }
    }
    return false; // None found.
}

function searchFilterAt(text, fields, arr, searchAt) {
    if (typeof fields === 'string') fields = [fields];
    text = text.toLowerCase();
    return arr.filter(o => {
        // const v = `${field ? o[field] : o}`.toLocaleLowerCase();
        let match = false;
        switch (searchAt) {
            case 'start': {
                // return v.toLowerCase().startsWith(text);
                fields.forEach(f => {
                    if (`${f ? o[f] : o}`.toLocaleLowerCase().startsWith(text)) match = true;
                });
                return match;
            }
            case 'end': {
                // return v.toLowerCase().endsWith(text);
                fields.forEach(f => {
                    if (`${f ? o[f] : o}`.toLocaleLowerCase().endsWith(text)) match = true;
                });
                return match;
            }
            case 'any': {
                // return v.toLowerCase().indexOf(text) > -1;
                fields.forEach(f => {
                    if (`${f ? o[f] : o}`.toLocaleLowerCase().indexOf(text) > -1) match = true;
                });
                return match;
            }
            case 'exact': {
                // return v.toLowerCase() === text;
                fields.forEach(f => {
                    if (`${f ? o[f] : o}`.toLocaleLowerCase() === text) match = true;
                });
                return match;
            }
            default: return false;
        }
    });
}

function toTitleCase(str) {
    return str.replace(/\b\w+/g, s => s.charAt(0).toUpperCase() + s.substr(1).toLowerCase());
}

export default {
    extend,
    has,
    searchFilterAt,
    toTitleCase
};



// WEBPACK FOOTER //
// ./src/util/Util.js